import BreadCrumb from "Components/Common/BreadCrumb";
import React, { useEffect, useRef, useState } from "react";
import { Card } from "reactstrap";
import filterIcon from "../../../assets/images/filter-icon.png";
import "./OrderReview.scss";
import searchIcon from "../../../assets/images/search-normal.png";
import productImage from "../../../assets/images/bykea.png";
import copy from "../../../assets/images/copy.png";
import OrderReviewCard from "./components/OrderReviewCard";
import axios from "axios";
import { createSelector } from "reselect";
import { useDispatch, useSelector } from "react-redux";
import {
  disputeReview,
  getReviewStaticThunk,
  replyReviewCreate,
} from "live-slices/thunk";
import ReviewReplyModal from "./components/ReviewReplyModal";
import DisputeModal from "./components/DisputeModal";
import { toast } from "react-toastify";

const OrderReview = (props: any) => {
  const [progress, setProgress] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [filterReplyType, setFilterReplyType] = useState("");
  const [filterContentType, setFilterContentType] = useState("");
  const [filterRating, setFilterRating] = useState("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [reviews, setReviews] = useState<any>();
  const [counts, setCounts] = useState<any>();
  const dispatch = useDispatch<any>();
    const [itemsPerPage, setItemsPerPage] = useState(20);
  const [firstInput, setFirstInput] = useState("");
  const [secondInput, setSecondInput] = useState("");
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const [keywordType, setKeywordType] = useState("");
  const [showModal, setShowModal] = useState({
    isVisible: false,
    color: false,
  });
  const [OrderReviewModal, setOrderReviewModal] = useState(false);
  const [disputeModal, setDisputeModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [selectedId, setSelectedId] = useState("");
  const [selectedItem, setSelectedItem] = useState<any>({});
  const toggleFilters = () => {
    setShowFilters((prev) => !prev);
  };

       const [selectedRows, setSelectedRows] = useState<string[]>([]);
    const [selectAll, setSelectAll] = useState(false);


  const selectReview = createSelector(
    (state: any) => state.Review,
    (reviewStatics) => reviewStatics?.reviewStatics
  );
  const reviewStatic = useSelector(selectReview);

  useEffect(() => {
    if (startDate && endDate) {
      onGetReviewsWithStatus(currentPage, "", "", "", "");
    }
  }, [startDate, endDate]);
 const handleItemsPerPageChange = (e:any) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to page 1 when count changes
  };
  const onGetReviewsWithStatus = async (
    page: number,
    replyType: string,
    contentType: string,
    rating: string,
    filterType: string
  ) => {
    try {
      let keyword = firstInput.trim() !== "" ? firstInput : secondInput;
      let finalKeywordType = "";
      if (!filterType && firstInput.trim() !== "") {
        finalKeywordType = "productId";
      } else if (!filterType && secondInput.trim() !== "") {
        finalKeywordType = "buyerName";
      } else {
        keyword = "";
      }

      const response = await axios.get(
        `api/v1/reviews?page=${page}&count=${itemsPerPage}&keyword=${keyword}&replyType=${replyType}&contentType=${contentType}&rating=${rating}&filterType=${filterType}&keywordType=${finalKeywordType}&stardate=${
          startDate ? new Date(startDate).getTime() : 0
        }&enddate=${endDate ? new Date(endDate).getTime() : 0}`
      );

      if (response?.data) {
        setReviews(response.data.data);
        setCounts(response.data.counts);
        setTotalPages(Math.ceil(response.data.totalCount / itemsPerPage));
        setStartDate(null);
        setEndDate(null);
      }
    } catch (err: any) {
      console.error(err);
    }
  };

  const onGetReviews = async (page: number) => {
    try {
      const response = await axios.get(
        `api/v1/reviews?page=${page}&count=${itemsPerPage}&keyword=${searchTerm}`
      );
      if (response?.data) {
        setReviews(response.data.data);
        setCounts(response.data.counts);
        setTotalPages(Math.ceil(response.data.totalCount / itemsPerPage));
      }
    } catch (err: any) {
    } finally {
    }
  };

   useEffect(() => {
        const handler = setTimeout(() => {
          onGetReviews(currentPage);
        }, 500);
    
        return () => {
          clearTimeout(handler);
        };
      }, [searchTerm, currentPage,itemsPerPage  ]);
      useEffect(() => {
          onGetReviews(currentPage);
      }, [currentPage,itemsPerPage  ]);
  

  // useEffect(() => {
  //   console.log(reviews);
  //   dispatch(getReviewStaticThunk());
  //   console.log(reviewStatic, "staticdata");
  //   onGetReviews(currentPage);
  // }, [ currentPage]);

  useEffect(() => {
    if (keywordType.length > 3) {
      onGetReviewsWithStatus(currentPage, "", "", "", "");
    }
  }, [keywordType]);

  const replyTypeFilters = [
    { label: "Replied", value: "replied" },
    { label: "No Reply", value: "noReply" },
  ];

  const contentTypeFilters = [
    { label: "With Content", value: "content" },
    { label: "With Image or Video", value: "imageOrVideo" },
  ];

  const ratingFilters = [
    { label: "1 Star", value: "1", id: "star-1" },
    { label: "2 Star", value: "2", id: "star-2" },
    { label: "3 Star", value: "3", id: "star-3" },
    { label: "4 Star", value: "4", id: "star-4" },
    { label: "5 Star", value: "5", id: "star-5" },
  ];

  const handleFilterTypeClick = (filterType: string) => {
    setFirstInput("");
    setSecondInput("");
    setFilterReplyType(filterType);
    onGetReviewsWithStatus(currentPage, filterType, "", "", "");
  };

  const handleFilterContentClick = (filterContentType: string) => {
    setFirstInput("");
    setSecondInput("");
    setFilterContentType(filterContentType);
    onGetReviewsWithStatus(currentPage, "", filterContentType, "", "");
  };

  const handleFilterRatingClick = (filterRating: string) => {
    setFirstInput("");
    setSecondInput("");
    setFilterRating(filterRating);
    onGetReviewsWithStatus(currentPage, "", "", filterRating, "");
  };

  const handleReply = (id: string, item: any) => {
    setSelectedId(id);
    setSelectedItem(item);
    setOrderReviewModal(true);
  };

  const handleDispute = (id: string, item: any) => {
    setSelectedId(id);
    setSelectedItem(item);
    setDisputeModal(true);
  };

  const handleSubmit = async (reason: string) => {
    if (selectedId) {
      const resp = await dispatch(
        replyReviewCreate({ id: selectedId, reply: reason })
      );
      if (resp.payload) {
        onGetReviews(currentPage);
        toast.success("Replied Submitted Successfully");
        setOrderReviewModal(false);
        setDisputeModal(false);
        setSelectedId("");
        setSelectedItem("");
      }
    }
  };

  const handleSubmitDispute = async (reason: string) => {
    if (selectedId) {
      const resp = await dispatch(
        disputeReview({ id: selectedId, reason: reason })
      );
      if (resp.payload) {
        onGetReviews(currentPage);
        toast.success("Review Disputed Successfully");
        setDisputeModal(false);
        setOrderReviewModal(false);
        setSelectedId("");
        setSelectedItem("");
      }
    }
  };

    const handlePageChange = (page: number) => {
      setCurrentPage(page);
    };

  return (
    <React.Fragment>
      <div className="page-content orderReviewPage">
        <ReviewReplyModal
          show={OrderReviewModal}
          onCloseClick={() => {
            setOrderReviewModal(false);
            setDisputeModal(false);
          }}
          selectedItem={selectedItem}
          onConfirm={handleSubmit}
        />
        <DisputeModal
          show={disputeModal}
          onCloseClick={() => {
            setDisputeModal(false);
            setOrderReviewModal(false);
          }}
          selectedItem={selectedItem}
          onConfirm={handleSubmitDispute}
        />
        <BreadCrumb
          title="Rating & Review Management"
          pageTitle="Orders"
          pageTitleRoute="/manage-orders"
        />
        <Card className="mainRatingCard mobile-hide">
          <h6>Performance Overview</h6>
          <div className="performanceFlexDv">
            <div className="ratingCard">
              <h5>
                Order Without <br></br> Review
              </h5>
              <h1>
                {(reviewStatic?.ordersWithoutReviewCount || 0)
                  .toString()
                  .substring(0, 4)}
              </h1>
              <span>New today: {reviewStatic?.newToday}</span>
            </div>
            <div className="ratingCard">
              <h5>
                Pending Reply to <br></br> Reviews
              </h5>
              <h1>
                {(reviewStatic?.pendingRepliesCount || 0)
                  .toString()
                  .substring(0, 4)}
              </h1>
              <span>New today: {reviewStatic?.newTodayPendingReplies}</span>
            </div>
            <div className="ratingCard">
              <h5>
                Product with <br></br> Review Coverage
              </h5>
              <h1>
                {(reviewStatic?.productWithReviewCoveragePercentage || 0)
                  .toString()
                  .substring(0, 4)}
                %
              </h1>
              <span>
                Reviewed Products: {reviewStatic.reviewedProductsCount}/
                {reviewStatic.totalProductsCount}
              </span>
              <div className="progress-bar">
                <div className="progress"></div>
              </div>
            </div>
            <div className="ratingCard">
              <h5>
                Positive Seller <br></br> Ratings
              </h5>
              <h1>
                {(reviewStatic?.positiveSellerRatingPercentage || 0)
                  .toString()
                  .substring(0, 4)}
                %
              </h1>
              <span>Target Rate: 0%</span>
              <div className="progress-bar">
                <div className="progress"></div>
              </div>
            </div>
          </div>
        </Card>
        <Card className="mainRatingCard navigationDv">
          <div className="serchNavigationDv">
            <div className="serchDv">
              <i className="bx bx-search"></i>
              <input
                type="text"
                placeholder="Search"
                data-testing-id="serachInput_review"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="paginationDv">
              <nav aria-label="Page navigation example">
                  
                <ul className="pagination detailPagepagi">
                  <select value={itemsPerPage} style={{margin:'5px'}} onChange={handleItemsPerPageChange}>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={80}>80</option>
          <option value={100}>100</option>
        </select>
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button
                      style={{
                        height: "26px",
                        display: "flex",
                        alignItems: "center",
                        border: "none",
                      }}
                      className="page-link"
                      onClick={() =>
                        setCurrentPage((prev) => Math.max(prev - 1, 1))
                      }
                    >
                      <i
                        style={{ height: "11px" }}
                        className="bx bxs-left-arrow"
                      ></i>
                    </button>
                  </li>
                   {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
  let startPage = 1;

  if (totalPages <= 5) {
    startPage = 1;
  } else if (currentPage <= 3) {
    startPage = 1;
  } else if (currentPage >= totalPages - 2) {
    startPage = totalPages - 4;
  } else {
    startPage = currentPage - 2;
  }

  return startPage + i;
                  }).map((page) => (
                    <div>
                      <li
                        className={`page-item ${
                          currentPage === page ? "active" : ""
                        }`}
                        key={page}
                      >
                        <button
                          style={{ height: "26px" }}
                          className="page-link orderPg"
                          onClick={() => setCurrentPage(page)}
                        >
                          {page}
                        </button>
                      </li>
                    </div>
                  ))}
                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link orderPg"
                      style={{
                        height: "26px !important",
                        display: "flex",
                        alignItems: "center",
                        border: "none",
                      }}
                      onClick={() =>
                        setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                      }
                    >
                      <i
                        className="bx bxs-right-arrow"
                        style={{ width: "6px", height: "11px" }}
                      ></i>
                    </button>
                  </li>
                   <select
    value={currentPage}
    onChange={(e) => handlePageChange(Number(e.target.value))}
    style={{
      margin: "0 10px",
      padding: "2px 6px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      fontSize: "13px",
    }}
  >
    {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNum) => (
      <option key={pageNum} value={pageNum}>
        Page {pageNum}
      </option>
    ))}
  </select>
                </ul>
              </nav>
            </div>
          </div>
          <table className="mobile-hide">
            <thead>
              <tr>
                <th className="firstChildTH" rowSpan={5}>
                  <div className="d-flex align-items-center gap-2">
                   <input
                       type="checkbox"
                            checked={selectedRows.length === (reviews?.length || 0)}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setSelectAll(checked);
                              if (checked) {
                                const allIds = (reviews || []).map((item: any) => item._id);
                                setSelectedRows(allIds);
                              } else {
                                setSelectedRows([]);
                              }
                            }}
                          />
                    <h6>Product</h6>
                  </div>
                </th>
                <th className="SecondChildTH">
                  <h6>Customer</h6>
                </th>
                <th className="ThirdChildTH">
                  <h6>Ratings</h6>
                </th>
                <th className="FourthChildTH">
                  <h6>Media</h6>
                </th>
                <th className="LastChildTH">
                  <div
                    onClick={toggleFilters}
                    data-testing-id="flter_Orderreview"
                    className="d-flex justify-content-end"
                  >
                    <div className="filter">
                      <img
                        src={filterIcon}
                        style={{
                          width: "10px",
                          height: "10px",
                          marginRight: "5px",
                        }}
                        alt=""
                      />
                      <h4 className="text-secondary mb-0 mt-1"> Filter </h4>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
          </table>

          {showFilters && (
            <div className="chipTodayContainer-main different-chip-main">
              <div className="chipTodayContainer">
                <div className="d-flex gap-3 align-items-center">
                  <div>
                    <a className="m-0">Status</a>
                  </div>
                  <div className="d-flex gap-2 align-items-center">
                    {replyTypeFilters.map((replyType) => (
                      <p
                        key={replyType.value}
                        className={`chipDv ${
                          filterReplyType === replyType.value ? "active" : ""
                        }`}
                        tabIndex={0}
                        data-testing-id={`selectFilters_EcommercerOrder_${replyType.value}`}
                        onClick={() => handleFilterTypeClick(replyType.value)}
                        onBlur={() => setFilterReplyType("")}
                      >
                        {replyType.label}
                      </p>
                    ))}
                  </div>
                </div>
                <div className="d-flex gap-3 align-items-center">
                  <div>
                    <a className="m-0">Content</a>
                  </div>
                  <div className="d-flex gap-2 align-items-center">
                    {contentTypeFilters.map((contentType) => (
                      <p
                        key={contentType.value}
                        className={`chipDv ${
                          filterContentType === contentType.value
                            ? "active"
                            : ""
                        }`}
                        tabIndex={0}
                        data-testing-id={`selectFilters_EcommercerOrder_${contentType.value}`}
                        onClick={() =>
                          handleFilterContentClick(contentType.value)
                        }
                        onBlur={() => setFilterContentType("")}
                      >
                        {contentType.label}
                      </p>
                    ))}
                  </div>
                </div>
                <div className="d-flex gap-3 align-items-center">
                  <div>
                    <a className="m-0">Overall Rating</a>
                  </div>
                  <div className="d-flex gap-2 align-items-center">
                    {ratingFilters.map((ratingFilter) => (
                      <p
                        key={ratingFilter.value}
                        className={`chipDv ${
                          filterRating === ratingFilter.value ? "active" : ""
                        }`}
                        tabIndex={0}
                        data-testing-id={`selectFilters_EcommercerOrder_${ratingFilter.id}`}
                        onClick={() =>
                          handleFilterRatingClick(ratingFilter.value)
                        }
                        onBlur={() => setFilterRating("")}
                      >
                        {ratingFilter.label}
                      </p>
                    ))}
                  </div>
                </div>
              </div>
              <div className="input-main">
                {/* <div className="input">
                    <input
                      type="text"
                      placeholder="Order Number"
                      data-testing-id="orderNumberInput_EcommercerOrder"
                      
                    />
                    <img src={searchIcon} alt="" />
                  </div> */}
                <div className="input">
                  <select name="" id="" data-testing-id="select_Productquality">
                    <option
                      value=""
                      data-testing-id="selectOption_Shippingservis"
                    >
                      Product Quality
                    </option>
                    <option
                      value=""
                      data-testing-id="selectOption_Sellerservis"
                    >
                      Select filters
                    </option>
                  </select>
                </div>
                <div className="input">
                  <select
                    name=""
                    id=""
                    data-testing-id="select_EcommercerOrder"
                  >
                    <option
                      value=""
                      data-testing-id="selectOption_EcommercerOrder"
                    >
                      Shipping Service
                    </option>
                    <option
                      value=""
                      data-testing-id="selectOption_EcommercerOrder"
                    >
                      Select filters
                    </option>
                  </select>
                </div>
                <div className="input">
                  <select
                    name=""
                    id=""
                    data-testing-id="select_EcommercerOrder"
                  >
                    <option
                      value=""
                      data-testing-id="selectOption_EcommercerOrder"
                    >
                      Seller Service
                    </option>
                    <option
                      value=""
                      data-testing-id="selectOption_EcommercerOrder"
                    >
                      Select filters
                    </option>
                  </select>
                </div>

                <div className="input">
                  <input
                    type="text"
                    placeholder="Product ID"
                    data-testing-id="producyNameInput_review"
                    value={firstInput}
                    onChange={(e) => {
                      setFirstInput(e.target.value);
                      setKeywordType("productId");
                    }}
                    onFocus={() => {
                      setFirstInput("");
                      setKeywordType("");
                    }}
                  />
                  <img src={searchIcon} alt="" />
                </div>
                <div className="input">
                  <input
                    type="text"
                    placeholder="Buyer Name"
                    data-testing-id="producyNameInput_buyerName"
                    value={secondInput}
                    onChange={(e) => {
                      setSecondInput(e.target.value);
                      setKeywordType("buyerName");
                    }}
                    onFocus={() => {
                      setSecondInput("");
                      setKeywordType("");
                    }}
                  />
                  <img src={searchIcon} alt="" />
                </div>
              </div>
              <div className="chipTodayContainer">
                <div className="input">
                  <input
                    type="date"
                    data-testing-id="startDateInput_EcommercerOrder"
                    placeholder="Start Date"
                    value={startDate || ""}
                    onChange={(e) => {
                      setStartDate(e.target.value);
                      if (
                        endDate &&
                        new Date(e.target.value) > new Date(endDate)
                      ) {
                        setEndDate(e.target.value);
                      }
                    }}
                  />

                  <input
                    type="date"
                    data-testing-id="endDateInput_EcommercerOrder"
                    placeholder="End Date"
                    value={endDate || ""}
                    onChange={(e) => {
                      if (
                        startDate &&
                        new Date(e.target.value) < new Date(startDate)
                      ) {
                        setErrorMessage(
                          "End date cannot be before start date!"
                        );
                        setShowModal({ isVisible: true, color: false });
                        setTimeout(() => {
                          setShowModal({ isVisible: false, color: false });
                        }, 1500);
                        return;
                      }

                      setEndDate(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </Card>
        {/* <Card className="mainRatingCard">
                    <div className="productCard">
              <img src={productImage} alt="" />
              <div>
              <h4> Toothpaste Cup Holder Protect...</h4>
              <h6>Order Item ID: <span>TS1247845748....495345</span><img src={copy}/></h6>
              </div>
                </div>
                </Card> */}
        <>
        <div className="cardMarResReview">
          {reviews && reviews.length > 0 ? (
            reviews.map((reviews: any, index: any) => (
              <OrderReviewCard
                key={reviews._id}
                reviews={reviews}
                index={index}
                setReviews={setReviews}
                setTotalPages={setTotalPages}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                onReply={() => handleReply(reviews._id, reviews)}
                onDispute={() => handleDispute(reviews._id, reviews)}
              />
            ))
          ) : (
            <h2>No Data Found!</h2>
          )}
          </div>
        </>
      </div>
    </React.Fragment>
  );
};

export default OrderReview;
